export const BASE_URLS = {
  __STASH_ENV__: 'https://login-edge.stash.com',
  edge: 'https://login-edge.stash.com',
  staging: 'https://login-staging.stash.com',
  production: 'https://login.stash.com',
};

export const CLIENT_IDS = {
  __STASH_ENV__: 'e0c11a43-b868-4a31-bb24-06a497b315b1',
  edge: 'f29b429f-5483-42e5-8ba6-4aeb02d5d3a9',
  staging: 'e9c5b819-702a-4617-ac77-4c82723df5b7',
  production: '92652692-61cc-48f6-9d41-3031f3031edc',
};

export const REDIRECT_URLS = {
  __STASH_ENV__: 'https://app-local.stash.com:9009/authorize',
  edge: 'https://app-edge.stash.com/authorize',
  staging: 'https://app-staging.stash.com/authorize',
  production: 'https://app.stash.com/authorize',
};

export const SUPPORTED_PRODUCTS = {
  purchase: 'pur',
};
